//      
import { getRect } from 'css-box-model';
                                                    
import { offsetByPosition } from './spacing';

export const offsetRectByPosition = (rect      , point          )       =>
  getRect(offsetByPosition(rect, point));



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/rect.js